import React, { useEffect, useState } from "react";
import Upload from "views/admin/profile/components/Upload";
import InputField from "components/fields/InputField";
import TextField from "components/fields/TextField";
import { toast } from "react-toastify";
import AdminDataService from "../../../services/admin.service";
import axios from "axios";
import Loading from "components/loading/Loading";
const Settings = () => {
  const [images, setImages] = useState([]);
  const [title, setTitle] = useState("");
  const [sideHeader, setSideHeader] = useState("");
  const [sideContent, setSideContent] = useState("");
  const [bannerHeader, setBannerHeader] = useState("");
  const [bannerDescription, setBannerDescription] = useState("");
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const resp = await AdminDataService.getLogos();
    if (resp.data && resp.data.status === "200") {
      setImages([resp.data.data[0].image_url]);
      setTitle(resp.data.data[0].title);
      setId(resp.data.data[0]._id);
      setSideHeader(resp.data.data[0].sideHeader);
      setSideContent(resp.data.data[0].sideContent);
      setBannerHeader(resp.data.data[0].bannerHeader);
      setBannerDescription(resp.data.data[0].bannerDescription);
    }
  };

  const handleImageUpload = (files) => {
    setImages(files);
  };

  const handleUpdate = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("sideHeader", sideHeader);
    formData.append("sideContent", sideContent);
    formData.append("bannerHeader", bannerHeader);
    formData.append("bannerDescription", bannerDescription);
    formData.append("id", id);
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    const res = await axios.put(
      `${process.env.REACT_APP_HTTPCOMMON}/logo/update-logo`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          auth: `${localStorage.getItem("auth")}`,
        },
        withCredentials: true,
      }
    );
    if (res.data && res.data.status === "200") {
      toast.success("Logo updated successfully!");
      setLoading(false);
      setTitle("");
      getData();
    } else {
      toast.error(
        res.data.message || "Something went wrong! Please try again later."
      );
      setLoading(false);
    }
    try {
    } catch (err) {
      toast.error("Something went wrong! Please try again later.");
      setLoading(false);
    }
  };

  return (
    <div className="!z-[1004] mx-auto mt-10 flex max-w-[850px] flex-col rounded-md bg-white px-[30px] pb-[40px] pt-[35px] dark:!bg-navy-700">
      {loading && <Loading message={`Updating logo`} />}

      <h1 className="mb-2 text-2xl font-bold">Logo Settings</h1>
      <div className="mb-[20px] w-full">
        <div className="w-full p-2">
          {images.length > 0 && (
            <Upload onChange={handleImageUpload} images={images} />
          )}
        </div>
      </div>
      <div className="flex w-full">
        <div className="w-full p-2">
          <InputField
            label="Logo title"
            placeholder="@logo_title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
      </div>

      <div className="mb-2 mt-5 w-full">
        <h1 className="mb-2 text-xl font-bold">Side Content Settings</h1>
        <div className="w-full p-2">
          <InputField
            label="Header"
            placeholder="@enter_header"
            type="text"
            value={sideHeader}
            onChange={(e) => setSideHeader(e.target.value)}
          />
        </div>
        <div className="w-full p-2">
          <TextField
            label="Content"
            placeholder="@enter_content"
            type="textarea"
            rows="3"
            value={sideContent}
            onChange={(e) => setSideContent(e.target.value)}
          />
        </div>
      </div>

      <div className="mb-2 mt-5 w-full">
        <h1 className="mb-2 text-xl font-bold">Banner Settings</h1>
        <div className="w-full p-2">
          <InputField
            label="Banner Header"
            placeholder="@enter_banner_header"
            type="text"
            value={bannerHeader}
            onChange={(e) => setBannerHeader(e.target.value)}
          />
        </div>
        <div className="w-full p-2">
          <TextField
            label="Banner Description"
            placeholder="@enter_banner_description"
            type="textarea"
            rows="3"
            value={bannerDescription}
            onChange={(e) => setBannerDescription(e.target.value)}
          />
        </div>
      </div>

      <button
        disabled={loading}
        onClick={handleUpdate}
        className="linear rounded-xl bg-gray-100 px-5 py-3 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
      >
        Update Settings
      </button>
    </div>
  );
};

export default Settings;
